export class ForbiddenApiError extends Error {
  constructor(message?: string) {
    super(message ?? 'Forbidden error occurred')
    Object.setPrototypeOf(this, ForbiddenApiError.prototype)
  }
}
